/*
 * Copyright (c) 2021 JCA Electronics ; Winnipeg; MB. All rights reserved.
 */
//SmartMap.Common.Models.ConfigurationModel

import { SectionControlMode } from './SectionControlMode';

export class ConfigurationModel {
  ErrorNotes: string;
  OverlapThreshold: number;
  Mode: SectionControlMode;
  LookAheadSecondsEntering: number;
  LookAheadSecondsExiting: number;
  SystemDelaySecondsEntering: number;
  SystemDelaySecondsExiting: number;
  DesiredOverlapMetersEntering: number;
  DesiredOverlapMetersExiting: number;
  MaxPopulation: number;
  MinPopulation: number;
  GPSOffsetSeconds: number;
  MachineID: string;

  constructor() {
    this.ErrorNotes = '';
    this.OverlapThreshold = 0;
    this.Mode = SectionControlMode.Binary;
    this.LookAheadSecondsEntering = 0;
    this.LookAheadSecondsExiting = 0;
    this.SystemDelaySecondsEntering = 0;
    this.SystemDelaySecondsExiting = 0;
    this.DesiredOverlapMetersEntering = 0;
    this.DesiredOverlapMetersExiting = 0;
    this.MaxPopulation = 0;
    this.MinPopulation = 0;
    this.GPSOffsetSeconds = 0;
    this.MachineID = '';
  }
}
